/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Error_FallbackInputs */

const en_form_error_fallback = /** @type {(inputs: Form_Error_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please check your input.`)
};

const de_form_error_fallback = /** @type {(inputs: Form_Error_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte überprüfen Sie Ihre Eingaben.`)
};

/**
* | output |
* | --- |
* | "Please check your input." |
*
* @param {Form_Error_FallbackInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const form_error_fallback = /** @type {((inputs?: Form_Error_FallbackInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Error_FallbackInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_form_error_fallback(inputs)
	return en_form_error_fallback(inputs)
});